import { render } from "./TextareaInput.vue?vue&type=template&id=7975efc8"
import script from "./TextareaInput.vue?vue&type=script&lang=js"
export * from "./TextareaInput.vue?vue&type=script&lang=js"

import "./TextareaInput.vue?vue&type=style&index=0&id=7975efc8&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__